export default "/images/b555371e9ae8fd0c4a74e99aee6b8f6d.avif";